import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import AuthenticationRoutes from './AuthenticationRoutes';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard')));

// pages routing

// profile
const MyInfo = Loadable(lazy(() => import('views/pages/Profile/MyInfo')));
const MyAttendances = Loadable(
  lazy(() => import('views/pages/Profile/MyAttendances'))
);
const MySalaries = Loadable(
  lazy(() => import('views/pages/Profile/MySalaries'))
);
const MyMobileBills = Loadable(
  lazy(() => import('views/pages/Profile/MyMobileBills'))
);

// employee management
const ActiveEmployees = Loadable(
  lazy(() => import('views/pages/Employees/ActiveEmployees'))
);
const SingleActiveEmployee = Loadable(
  lazy(() =>
    import('views/pages/Employees/ActiveEmployees/SingleActiveEmployee')
  )
);
const ActiveEmployeeInfo = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/ActiveEmployeeInfo'
    )
  )
);
const LoginUserCreation = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/LoginUserCreation'
    )
  )
);
const SalaryRecord = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/SalaryRecord'
    )
  )
);
const EmployeeLetter = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/EmployeeLetter'
    )
  )
);
const AccessControl = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/AccessControl'
    )
  )
);
const EmployeeAttendance = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/EmployeeAttendance'
    )
  )
);
const EmployeeLeaves = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/EmployeeLeaves'
    )
  )
);
const EmployeePaidSalaries = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/EmployeePaidSalaries'
    )
  )
);
const EmployeeMobileBill = Loadable(
  lazy(() =>
    import(
      'views/pages/Employees/ActiveEmployees/SingleActiveEmployee/EmployeeMobileBill'
    )
  )
);

const ResignedEmployees = Loadable(
  lazy(() => import('views/pages/Employees/ResignedEmployees'))
);
const TransferEmployee = Loadable(
  lazy(() => import('views/pages/Employees/TransferEmployee'))
);

// employees libraries
const EmployeeLibrary = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary'))
);
const Designation = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/Designation'))
);
const Department = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/Department'))
);
const Area = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/Area'))
);
const BranchPage = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/Branch'))
);
const Religion = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/Religion'))
);
const MaritalStatus = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/MaritalStatus'))
);
const EducationDegree = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/EducationDegree'))
);
const LetterType = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/LetterType'))
);
const LeaveType = Loadable(
  lazy(() => import('views/pages/Employees/EmployeeLibrary/LeaveType'))
);

const HolidayList = Loadable(lazy(() => import('views/pages/HolidayList')));

// attendances
const DailyAttendance = Loadable(
  lazy(() => import('views/pages/Attendance/DailyAttendance'))
);
const AllAttendance = Loadable(
  lazy(() => import('views/pages/Attendance/AllAttendance'))
);

// present management
const ManualPresent = Loadable(
  lazy(() => import('views/pages/PresentManagement/ManualPresent'))
);
const PresentNow = Loadable(
  lazy(() => import('views/pages/PresentManagement/PresentNow'))
);
const WifiAttendance = Loadable(
  lazy(() => import('views/pages/PresentManagement/WifiAttendance'))
);

const MyLeaves = Loadable(
  lazy(() => import('views/pages/LeaveManagement/MyLeaves'))
);
const PendingLeaves = Loadable(
  lazy(() => import('views/pages/LeaveManagement/PendingLeaves'))
);
const ApprovedLeaves = Loadable(
  lazy(() => import('views/pages/LeaveManagement/ApprovedLeaves'))
);
const LeaveSummary = Loadable(
  lazy(() => import('views/pages/LeaveManagement/LeaveSummary'))
);

// salary management
const MonthlySalaries = Loadable(
  lazy(() => import('views/pages/SalaryManagement/MonthlySalaries'))
);
const PaySalary = Loadable(
  lazy(() => import('views/pages/SalaryManagement/PaySalary'))
);
const LateDeduction = Loadable(
  lazy(() => import('views/pages/SalaryManagement/LateDeduction'))
);
const PresentSalary = Loadable(
  lazy(() => import('views/pages/SalaryManagement/PresentSalary'))
);

// end pages

// quotation management
// quotations
const AllQuotations = Loadable(
  lazy(() => import('views/quotations/Quotations/AllQuotations'))
);
const NewQuotations = Loadable(
  lazy(() => import('views/quotations/Quotations/NewQuotations'))
);
const SentToClient = Loadable(
  lazy(() => import('views/quotations/Quotations/SentToClient'))
);
const AcceptedQuotations = Loadable(
  lazy(() => import('views/quotations/Quotations/AcceptedQuotations'))
);
const DeclinedQuotations = Loadable(
  lazy(() => import('views/quotations/Quotations/DeclinedQuotations'))
);
const AnalyzeDeclined = Loadable(
  lazy(() => import('views/quotations/Quotations/AnalyzeDeclined'))
);

// product management
const ProductList = Loadable(
  lazy(() => import('views/quotations/ProductManagement/ProductList'))
);
const DiscontinuedProducts = Loadable(
  lazy(() => import('views/quotations/ProductManagement/DiscontinuedProducts'))
);
const BrandList = Loadable(
  lazy(() => import('views/quotations/ProductManagement/BrandList'))
);

// client management
const ClientList = Loadable(
  lazy(() => import('views/quotations/ClientManagement/ClientList'))
);
const InactiveClient = Loadable(
  lazy(() => import('views/quotations/ClientManagement/InactiveClient'))
);

// offices
// conveyances
const MyConveyances = Loadable(
  lazy(() => import('views/offices/Conveyances/MyConveyances'))
);
const PendingConveyances = Loadable(
  lazy(() => import('views/offices/Conveyances/PendingConveyances'))
);
const AllConveyances = Loadable(
  lazy(() => import('views/offices/Conveyances/AllConveyances'))
);
const ConveyanceLibrary = Loadable(
  lazy(() => import('views/offices/Conveyances/ConveyanceLibrary'))
);
const ConveyanceCategory = Loadable(
  lazy(() =>
    import('views/offices/Conveyances/ConveyanceLibrary/ConveyanceCategory')
  )
);
const VehicleType = Loadable(
  lazy(() => import('views/offices/Conveyances/ConveyanceLibrary/VehicleType'))
);

// bills
const MyBills = Loadable(lazy(() => import('views/offices/Bills/MyBills')));
const PendingBills = Loadable(
  lazy(() => import('views/offices/Bills/PendingBills'))
);
const AllBills = Loadable(lazy(() => import('views/offices/Bills/AllBills')));
const BillLibrary = Loadable(
  lazy(() => import('views/offices/Bills/BillLibrary'))
);
const BillCategory = Loadable(
  lazy(() => import('views/offices/Bills/BillLibrary/BillCategory'))
);
const Shops = Loadable(
  lazy(() => import('views/offices/Bills/BillLibrary/Shops'))
);
const BillUom = Loadable(
  lazy(() => import('views/offices/Bills/BillLibrary/BillUom'))
);

// mobile bills
const MobileBill = Loadable(
  lazy(() => import('views/offices/MobileBills/MobileBill'))
);
const MobileList = Loadable(
  lazy(() => import('views/offices/MobileBills/MobileList'))
);
const MobileUser = Loadable(
  lazy(() => import('views/offices/MobileBills/MobileUser'))
);
const MonthlyReceipt = Loadable(
  lazy(() => import('views/offices/MobileBills/MonthlyReceipt'))
);
const EmployeeBillSummary = Loadable(
  lazy(() => import('views/offices/MobileBills/EmployeeBillSummary'))
);
const MobileBillSummary = Loadable(
  lazy(() => import('views/offices/MobileBills/MobileBillSummary'))
);

// report
const ExpenseSummary = Loadable(
  lazy(() => import('views/offices/Report/ExpenseSummary'))
);
const MonthSummary = Loadable(
  lazy(() => import('views/offices/Report/MonthSummary'))
);
const ConveyanceSummary = Loadable(
  lazy(() => import('views/offices/Report/ConveyanceSummary'))
);
const BranchWiseSummary = Loadable(
  lazy(() => import('views/offices/Report/ConveyanceSummary/BranchWiseSummary'))
);
const EmployeeWiseSummary = Loadable(
  lazy(() =>
    import('views/offices/Report/ConveyanceSummary/EmployeeWiseSummary')
  )
);
const BillSummary = Loadable(
  lazy(() => import('views/offices/Report/BillSummary'))
);

// end offices

// utilities routing

// setting routing
const ManageUser = Loadable(lazy(() => import('views/setting/ManageUser')));
const SingleUser = Loadable(
  lazy(() => import('views/setting/ManageUser/SingleUser'))
);
const UserInfo = Loadable(
  lazy(() => import('views/setting/ManageUser/SingleUser/UserInfo'))
);
const UserPermission = Loadable(
  lazy(() => import('views/setting/ManageUser/SingleUser/UserPermission'))
);

const AttendanceSetting = Loadable(
  lazy(() => import('views/setting/AttendanceSetting'))
);

// support routing
const Support = Loadable(lazy(() => import('views/support')));

// Support error routing
const Error404 = Loadable(lazy(() => import('views/Error404')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <PrivateRoute />,
  children: [
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          path: '/',
          element: <Navigate to="dashboard" replace={true} />,
        },
        {
          path: 'dashboard',
          element: <Navigate to="default" replace={true} />,
        },
        {
          path: 'dashboard/default',
          element: <DashboardDefault />,
        },
        {
          path: 'pages',
          children: [
            {
              path: 'profile',
              children: [
                {
                  path: 'my-info',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['admin', 'user']}
                      allowedCodes={['my-info']}
                    >
                      <MyInfo />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'my-attendances',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['admin', 'user']}
                      allowedCodes={['my-attendances']}
                    >
                      <MyAttendances />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'my-salaries',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['admin', 'user']}
                      allowedCodes={['my-salaries']}
                    >
                      <MySalaries />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'my-mobile-bills',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['admin', 'user']}
                      allowedCodes={['my-mobile-bills']}
                    >
                      <MyMobileBills />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'employee-management',
              children: [
                {
                  path: 'employees',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['employees']}
                    >
                      <ActiveEmployees />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'employees/:id',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['employees']}
                    >
                      <SingleActiveEmployee />
                    </AuthenticationRoutes>
                  ),
                  children: [
                    {
                      path: '',
                      element: <ActiveEmployeeInfo />,
                    },
                    {
                      path: 'login-user',
                      element: <LoginUserCreation />,
                    },
                    {
                      path: 'salary',
                      element: <SalaryRecord />,
                    },
                    {
                      path: 'letters',
                      element: <EmployeeLetter />,
                    },
                    {
                      path: 'access',
                      element: <AccessControl />,
                    },
                    {
                      path: 'attendance',
                      element: <EmployeeAttendance />,
                    },
                    {
                      path: 'leaves',
                      element: <EmployeeLeaves />,
                    },
                    {
                      path: 'paid-salaries',
                      element: <EmployeePaidSalaries />,
                    },
                    {
                      path: 'mobile-bills',
                      element: <EmployeeMobileBill />,
                    },
                  ],
                },
                {
                  path: 'resigned-employees',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['resigned-employees']}
                    >
                      <ResignedEmployees />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'transfer-employees',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin']}
                      allowedCodes={['transfer-employees']}
                    >
                      <TransferEmployee />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'employee-library',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['employee-library']}
                    >
                      <EmployeeLibrary />
                    </AuthenticationRoutes>
                  ),
                  children: [
                    {
                      path: 'designation',
                      element: <Designation />,
                    },
                    {
                      path: 'department',
                      element: <Department />,
                    },
                    {
                      path: 'area',
                      element: <Area />,
                    },
                    {
                      path: 'branch',
                      element: <BranchPage />,
                    },
                    {
                      path: 'religion',
                      element: <Religion />,
                    },
                    {
                      path: 'marital-status',
                      element: <MaritalStatus />,
                    },
                    {
                      path: 'education-degree',
                      element: <EducationDegree />,
                    },
                    {
                      path: 'leave-type',
                      element: <LeaveType />,
                    },
                    {
                      path: 'letter-type',
                      element: <LetterType />,
                    },
                  ],
                },
              ],
            },
            {
              path: 'holiday-list',
              element: (
                <AuthenticationRoutes
                  allowedRoles={['super_admin', 'admin']}
                  allowedCodes={['holiday-list']}
                >
                  <HolidayList />
                </AuthenticationRoutes>
              ),
            },
            {
              path: 'attendances',
              children: [
                {
                  path: 'daily-attendance',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['daily-attendance']}
                    >
                      <DailyAttendance />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'all-attendance',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['all-attendance']}
                    >
                      <AllAttendance />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'salary-management',
              children: [
                {
                  path: 'monthly-salaries',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['monthly-salaries']}
                    >
                      <MonthlySalaries />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'pay-salary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['pay-salary']}
                    >
                      <PaySalary />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'late-deduction',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['late-deduction']}
                    >
                      <LateDeduction />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'present-salary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['present-salary']}
                    >
                      <PresentSalary />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'present-management',
              children: [
                {
                  path: 'geo-attendance',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['admin', 'user']}
                      allowedCodes={['geo-attendance']}
                    >
                      <PresentNow />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'wifi-attendance',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['wifi-attendance']}
                    >
                      <WifiAttendance />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'manual-present',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['manual-present']}
                    >
                      <ManualPresent />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'leave-management',
              children: [
                {
                  path: 'my-leaves',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['admin', 'user']}
                      allowedCodes={['my-leaves']}
                    >
                      <MyLeaves />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'pending-leaves',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['pending-leaves']}
                    >
                      <PendingLeaves />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'approved-leaves',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['approved-leaves']}
                    >
                      <ApprovedLeaves />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'leave-summary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['leave-summary']}
                    >
                      <LeaveSummary />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
          ],
        },

        {
          path: 'quotations',
          children: [
            {
              path: 'quotations',
              children: [
                {
                  path: 'all-quotations',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['all-quotations']}
                    >
                      <AllQuotations />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'draft-quotations',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['draft-quotations']}
                    >
                      <NewQuotations />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'sent-to-client',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['sent-to-client']}
                    >
                      <SentToClient />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'accepted',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['sent-to-client']}
                    >
                      <AcceptedQuotations />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'declined',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['sent-to-client']}
                    >
                      <DeclinedQuotations />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'analyze-declined',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['analyze-declined']}
                    >
                      <AnalyzeDeclined />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'product-management',
              children: [
                {
                  path: 'product-list',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['product-list']}
                    >
                      <ProductList />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'discontinued-products',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['discontinued-products']}
                    >
                      <DiscontinuedProducts />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'brand-list',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['brand-list']}
                    >
                      <BrandList />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'client-management',
              children: [
                {
                  path: 'client-list',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['client-list']}
                    >
                      <ClientList />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'inactivated-clients',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin', 'user']}
                      allowedCodes={['inactivated-clients']}
                    >
                      <InactiveClient />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
          ],
        },
        {
          path: 'offices',
          children: [
            {
              path: 'conveyances',
              children: [
                {
                  path: 'my-conveyances',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['admin', 'user']}
                      allowedCodes={['my-conveyances']}
                    >
                      <MyConveyances />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'pending-conveyances',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['pending-conveyances']}
                    >
                      <PendingConveyances />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'all-conveyances',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['all-conveyances']}
                    >
                      <AllConveyances />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'conveyance-library',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['conveyance-library']}
                    >
                      <ConveyanceLibrary />
                    </AuthenticationRoutes>
                  ),
                  children: [
                    {
                      path: '',
                      element: <ConveyanceCategory />,
                    },
                    {
                      path: 'vehicle-type',
                      element: <VehicleType />,
                    },
                  ],
                },
              ],
            },
            {
              path: 'bills',
              children: [
                {
                  path: 'my-bills',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['admin', 'user']}
                      allowedCodes={['my-bills']}
                    >
                      <MyBills />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'pending-bills',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['pending-bills']}
                    >
                      <PendingBills />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'all-bills',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['all-bills']}
                    >
                      <AllBills />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'bill-library',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['bill-library']}
                    >
                      <BillLibrary />
                    </AuthenticationRoutes>
                  ),
                  children: [
                    {
                      path: '',
                      element: <BillCategory />,
                    },
                    {
                      path: 'supplier',
                      element: <Shops />,
                    },
                    {
                      path: 'uom',
                      element: <BillUom />,
                    },
                  ],
                },
              ],
            },
            {
              path: 'manage-mobile-bill',
              children: [
                {
                  path: 'mobile-bills',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['mobile-bills']}
                    >
                      <MobileBill />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'mobile-no-list',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['mobile-no-list']}
                    >
                      <MobileList />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'mobile-no-user',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['mobile-no-user']}
                    >
                      <MobileUser />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'monthly-receipt',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['monthly-receipt']}
                    >
                      <MonthlyReceipt />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'user-bill-summary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['user-bill-summary']}
                    >
                      <EmployeeBillSummary />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'mobile-no-summary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['mobile-no-summary']}
                    >
                      <MobileBillSummary />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'report',
              children: [
                {
                  path: 'expense-summary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['expense-summary']}
                    >
                      <ExpenseSummary />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'month-summary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['month-summary']}
                    >
                      <MonthSummary />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'conveyance-summary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['conveyance-summary']}
                    >
                      <ConveyanceSummary />
                    </AuthenticationRoutes>
                  ),
                  children: [
                    {
                      path: '',
                      element: <BranchWiseSummary />,
                    },
                    {
                      path: 'employee-summary',
                      element: <EmployeeWiseSummary />,
                    },
                  ],
                },
                {
                  path: 'bill-summary',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['bill-summary']}
                    >
                      <BillSummary />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
          ],
        },
        {
          path: 'utils',
          children: [
            {
              path: 'setting',
              children: [
                {
                  path: 'manage-user',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['manage-user']}
                    >
                      <ManageUser />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'manage-user/:id',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['manage-user']}
                    >
                      <SingleUser />
                    </AuthenticationRoutes>
                  ),
                  children: [
                    {
                      path: '',
                      element: <UserInfo />,
                    },
                    {
                      path: 'permission',
                      element: <UserPermission />,
                    },
                  ],
                },
                {
                  path: 'attendance-setting',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin']}
                      allowedCodes={['attendance-setting']}
                    >
                      <AttendanceSetting />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'support',
              element: <Support />,
            },
          ],
        },
        {
          path: '/*',
          element: <Error404 />,
        },
      ],
    },
  ],
};

export default MainRoutes;
